import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d5d280d2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=d5d280d2&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=d5d280d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d280d2",
  null
  
)

export default component.exports